// WP-C1.5 (AVQ-1/2, TZ-4): the paste-a-window check.
import { availabilityCheckResponseSchema, type AvailabilityCheckResponse } from '@pfos/shared';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { api } from './api';

export function useCheckAvailability(): UseMutationResult<
  AvailabilityCheckResponse,
  Error,
  string
> {
  return useMutation({
    mutationFn: async (text) =>
      availabilityCheckResponseSchema.parse(await api.post('/api/v1/availability/check', { text })),
  });
}
